import { FormattedMessage } from 'react-intl';

import PrimaryButton from '@components/buttons/PrimaryButton';
import styles from '@components/expertSection/schedule/ScheduleSession.module.css';
import Heading1 from '@components/typography/Heading1';
import Hyperlink from '@components/typography/Hyperlink';
import useMyClient from '@hooks/useMyClient';
import { GetJourneyWithExpertAndConsultsQuery } from '@typing/Generated';
import { imageUrl } from '@utils/imageUtils';
import { journeyRoute } from '@utils/routeUtils';

type Props = {
  journey: GetJourneyWithExpertAndConsultsQuery['journey'];
};

const Booked = ({ journey }: Props) => {
  const myClient = useMyClient();

  return (
    <div className={styles.booked}>
      <Heading1>
        <FormattedMessage id="pages.consults.booked.yourBooked" />
      </Heading1>
      <div className={styles.return}>
        <PrimaryButton
          icon="listCheck"
          routerLink={journeyRoute({ journeyId: journey.id, linkAfterJourney: '/care-plan', myClient })}
          size="large"
          textKey="pages.consults.booked.return"
        />
        <Hyperlink routerLink={journeyRoute({ journeyId: journey.id, linkAfterJourney: '/expert', myClient })}>
          <FormattedMessage id="pages.consults.booked.viewSchedule" />
        </Hyperlink>
      </div>
      <img className={styles.smileImg} src={imageUrl('manSittingSmiles')} />
    </div>
  );
};

export default Booked;
